import angular from 'angular';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import CaseCheckService from './case-check-modal.service';

export default angular
  .module('verifyApp.case-check-modal', [uiRouter, uiBootstrap])
  .service('CaseCheckService', CaseCheckService)
  .name;



// WEBPACK FOOTER //
// ./client/components/case-check-modal/index.js